import { Web3Auth, IProvider } from '@web3auth/modal';
import EthereumRpc from './evm.web3';
import StakingCall from './staking';
import AlchemyApi from '../alchemy';
import { LOCAL_SESSION } from '../common/name-space';
import { TypeStakingCall } from '@/types';
import { AdminWeb3 } from './admin/adminWeb3';

export default class Web3AuthCall {
  private web3auth: Web3Auth;
  private provider!: IProvider | null;
  private rpc!: EthereumRpc;
  private stakingCall!: StakingCall;
  private alchemy: AlchemyApi;
  private adminWeb3: AdminWeb3;
  private isInitialized: boolean = false;

  constructor(web3: Web3Auth, provider: IProvider) {
    this.web3auth = web3;
    this.provider = provider;
    this.stakingCall = new StakingCall(provider);
    this.alchemy = new AlchemyApi();
    this.adminWeb3 = new AdminWeb3();
  }

  // 비동기 초기화 메서드
  async initialize(): Promise<void> {
    try {
      // EthereumRpc의 정적 팩토리 메서드 사용
      this.rpc = await EthereumRpc.create(this.provider!);
      this.stakingCall = new StakingCall(this.provider!);
      this.isInitialized = true;
    } catch (error) {
      console.error('Web3AuthCall 초기화 중 오류 발생:', error);
      this.isInitialized = false;
    }
  }

  // 정적 팩토리 메서드
  static async create(web3: Web3Auth, provider: IProvider): Promise<Web3AuthCall> {
    const instance = new Web3AuthCall(web3, provider);
    await instance.initialize();
    return instance;
  }

  // 초기화 상태 확인
  isReady(): boolean {
    return this.isInitialized;
  }

  // 삭제예정
  connected(): boolean {
    return this.web3auth.connected;
  }
  async getAddress(): Promise<string> {
    const addr = await this.rpc.getAddress0();
    // const addresses: string[] = await this.rpc.getAccounts()!;
    return addr; // addresses[0];
  }
  getWeb3auth() {
    return this.web3auth;
  }

  getProvider() {
    return this.provider;
  }

  getRpc() {
    return this.rpc;
  }
  getAlchemy() {
    return this.alchemy;
  }
  getAdminWeb3() {
    return this.adminWeb3;
  }

  getStakingCall() {
    return this.stakingCall;
  }
  async callStaking<T extends keyof TypeStakingCall>(aFunc: T, aContractAddr: string, args?: any[T]) {
    const stakingCall = this.getStakingCall() as TypeStakingCall;
    // aFunc에 해당하는 함수가 있는지 확인하고 호출합니다.
    if (typeof stakingCall[aFunc] !== 'function') {
      console.error(`Function ${aFunc} does not exist on stakingCall object`);
    }
    const re = await stakingCall[aFunc](aContractAddr, args);
    return re;
  }
  async getUserInfo() {
    // : Promise<OpenloginUserInfo> | undefined
    const re = await this.web3auth.getUserInfo();
    return re;
  }
  async logout() {
    this.setProvider(null);
    localStorage.removeItem(LOCAL_SESSION);
    await this.web3auth.logout();
    // window.location.reload();
  }
  setProvider(_provider: IProvider | null) {
    this.provider = _provider;
  }
}
